import type { MessagingSendMessage201AllOfBasicInfoAllOf } from './messagingSendMessage201AllOfBasicInfoAllOf';
import type { MessagingSendMessage201AllOfBasicInfoAllOfTwo } from './messagingSendMessage201AllOfBasicInfoAllOfTwo';

export type MessagingSendMessage201AllOfBasicInfo = MessagingSendMessage201AllOfBasicInfoAllOf & MessagingSendMessage201AllOfBasicInfoAllOfTwo;
